let boxElement;

/**
 * Init sortable.
 *
 * @param   {Node}  container
 * @param   {Object}  settings
 * @return  {Void}
 */
function initSortable(container, settings = {}) {
	boxElement = container.firstElementChild.cloneNode(true);

	new Sortable(container, settings);

	disableSubmitButton();
}

/**
 * All boxes filled.
 *
 * @param   {NodeList}  items
 * @return  {Boolean}
 */
function allBoxesFilled(items) {
	return Array.from(items).every(box => box.querySelector('.product-card'));
}

/**
 * At least two boxes filled.
 *
 * @param   {NodeList}  items
 * @return  {Boolean}
 */
function atLeastTwoBoxesFilled(items) {
    return Array.from(items).filter(box => box.querySelector('.product-card')).length >= 2;
}

/**
 * Get first empty box.
 *
 * @param   {NodeList}  boxes
 * @return  {Node}
 */
function getFirstEmptyBox(boxes) {
	for (let box of boxes) {
		if (!box.querySelector('.product-card')) {
			return box;
		}
	}
	return null;  
}
  
/**
 * Fill empty box.
 *
 * @param   {Node}  item
 * @return  {Void}
 */ 
function fillEmptyBox(item) {
	const cartBoxes = document.querySelectorAll('.cart-box');
  
	if (allBoxesFilled(cartBoxes)) {
		return;
	}
  
	const firstEmptyBox = getFirstEmptyBox(cartBoxes);
	if (firstEmptyBox) {
		firstEmptyBox.appendChild(item);
	}

	firstEmptyBox.classList.add('is-active');
}

/**
 * Add a product to a cart box.
 * 
 * @param {Node} productElement 
 * @return  {Void}
 */
function addProductToCart(productElement) {
	const cartBoxes = document.querySelectorAll('.cart-box');
	const availableBox = Array.from(cartBoxes).find(box => !box.querySelector('.product-card'));
  
	if (availableBox) {
	  const productClone = productElement.cloneNode(true);
	  availableBox.appendChild(productClone);
  
	  const cartItems = document.querySelectorAll('.cart-box .product-card');
	  addRemoveButtonToCartItems(cartItems);
  
	  /*updateTotalPrice();
	  updateBoxCount();*/
	}
}

/**
 * Add a remove button to each cart item.
 * 
 * @param {NodeList} cartItems
 * @return  {Void}
 */
function addRemoveButtonToCartItems(cartItems) {
	cartItems.forEach(item => {
		if (item.querySelector('.js-btn-remove')) return;

		const removeButtonContainer = document.createElement('div');
		removeButtonContainer.classList.add('product-card-remove');

		const removeButton = document.createElement('button');
		removeButton.classList.add('js-btn-remove');

		removeButtonContainer.appendChild(removeButton);
		item.appendChild(removeButtonContainer);

		// Add remove functionality
		removeButton.addEventListener('click', () => {
			item.closest('li').remove();
			updateTotalPrice();
			updateEmptyBoxes();
			disableAddToCartButtons();
			disableSubmitButton();
		});
	});
}

/**
 * Calculate the discount based on the total price.
 * 
 * @param {Number} total
 * @returns {Number}
 */
function getDiscount(total) {
	if (total >= 200) return 0.15;  // 15% discount
	if (total >= 150) return 0.10;  // 10% discount
	return 0;  
}

/**
 * Update total price.
 *
 * @return  {Void}
 */
function updateTotalPrice() {
	let total = 0;
	const cartItems = document.querySelectorAll('.cart-box .product-card');

	cartItems.forEach(item => {
		total += parseFloat(item.getAttribute('data-price'));
	});

	const discount = getDiscount(total);
	const discountAmount = total * discount;
	const finalPrice = total - discountAmount;

	const pricingContainer = document.querySelector('.js-pricing');
	const initialPriceRow = pricingContainer.querySelector('.pricing__initial');
	const discountPriceRow = pricingContainer.querySelector('.pricing__discount');
	const totalPriceRow = pricingContainer.querySelector('.pricing__total');

	totalPriceRow.querySelector('span').textContent = Math.ceil(finalPrice);

	if (discountAmount > 0) {
		discountPriceRow.querySelector('span').textContent = Math.ceil(discountAmount);
		initialPriceRow.querySelector('span').textContent = Math.ceil(total);
		pricingContainer.classList.add('is-discounted');
	} else {
		pricingContainer.classList.remove('is-discounted');
	}
}


/**
 * Add box.
 *
 * @return  {Void}
 */
function addBox() {
	const container = document.querySelector('.cart-boxes');
	const newBox = boxElement.cloneNode(true);
	container.appendChild(newBox);
}

/**
 * Update box count.
 *
 * @return  {Void}
 */
function updateBoxCount() {
	const container = document.querySelector('.cart-boxes');
	const boxes = document.querySelectorAll('.cart-box');

	if (allBoxesFilled(boxes)) {
		addBox();
	}

	disableAddToCartButtons();
	disableSubmitButton();
}

/**
 * Update empty boxes.
 *
 * @return  {Void}
 */
function updateEmptyBoxes() {
	const boxes = document.querySelectorAll('.cart-box');
	const emptyBoxes = Array.from(boxes).filter(box => !box.querySelector('.product-card'));

	if (boxes.length > 2) {
		while (emptyBoxes.length > 1) {
			const extraEmptyBox = emptyBoxes.pop();
			extraEmptyBox.remove();
		}
	}
}

/**
 * Attach add button event
 *
 * @return  {Void}
 */
function attachAddButtonEvent(item) {
	const addToCartButton = item.querySelector('.card-actions button');
	
	if (addToCartButton) {
		addToCartButton.addEventListener('click', () => {
			addProductToCart(item.closest('li'));
			updateTotalPrice();
			updateBoxCount();
		});
	}
}

/**
 * Disable add to cart buttons.
 *
 * @return  {Void}
 */
function disableAddToCartButtons() {
	const cartBoxes = document.querySelectorAll('.cart-box');
	const addToCartButtons = document.querySelectorAll('.product-card .card-actions button');

	// Check if all boxes are filled
	if (allBoxesFilled(cartBoxes)) {
		addToCartButtons.forEach(button => {
			button.disabled = true;  // Disable all buttons
		});
	} else {
		addToCartButtons.forEach(button => {
			button.disabled = false;  // Enable the buttons again
		});
	}
}

/**
 * Disable submit button.
 *
 * @return  {Void}
 */
function disableSubmitButton() {
	const cartBoxes = document.querySelectorAll('.cart-box');
	const submitButton = document.querySelector('button#submit-btn');

	if (atLeastTwoBoxesFilled(cartBoxes)) {
		submitButton.disabled = false;
	} else {
		submitButton.disabled = true;
	}
}

/**
 * Is touch device.
 * 
 * @returns {Boolean}
 */
function isTouchDevice() {
	return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

if (isTouchDevice()) {
	document.querySelector('body').classList.add('is-touch-device');
} else {
	document.querySelector('body').classList.remove('is-touch-device');
}

//Init product list instance.
const productList = document.querySelector('.js-products-list');
const productListSettings = {
	filter: '.product-card:not([data-price])', 
	group: {
		name: 'products',
		pull: 'clone',  
		put: false,     
	},
	sort: false,     
	animation: 150,
	onStart(event) {
		const firstEmptyBox = getFirstEmptyBox(document.querySelectorAll('.cart-box'));
		firstEmptyBox.classList.add('is-active');
	},
	onEnd(event) {
		document.querySelectorAll('.cart-boxes .cart-box').forEach(box => box.classList.remove('is-active'));
	}
};
initSortable(productList, productListSettings);

//Init cart boxes instance.
const cartBoxesContainer = document.querySelector('.cart-boxes');
const cartBoxesSettings = {
	group: 'products',  
	animation: 150,
	sort: false,  
	onAdd(event) {
		const draggedItem = event.item;
		fillEmptyBox(draggedItem);  
		
		const cartItems = document.querySelectorAll('.cart-box .product-card');
      	addRemoveButtonToCartItems(cartItems);
		
		updateTotalPrice();
		updateBoxCount();
		attachAddButtonEvent(event.clone);
	}
};
initSortable(cartBoxesContainer, cartBoxesSettings);


document.querySelectorAll('.product-card').forEach((product) => attachAddButtonEvent(product));

function BundleaddToCart() {
  // Get all the product IDs from the product cards
  const productCards = document.querySelectorAll('#bundle-shopping-cart .product-card');
  

  let productsToAdd = {};

  productCards.forEach(function(card) {
    const productId = card.getAttribute('data-prodid');
    
    if (productId) {
      
      if (productsToAdd[productId]) {
        productsToAdd[productId] += 1;
      } else {
        // Otherwise, initialize the quantity to 1
        productsToAdd[productId] = 1;
      }
    }
  });
  

  let itemsToAdd = [];
  for (const productId in productsToAdd) {
    itemsToAdd.push({
      id: productId,
      quantity: productsToAdd[productId]
    });
  }
  

  if (itemsToAdd.length > 0) {
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: itemsToAdd
      })
    })
    .then(response => response.json())
    .then(() => {
     
      const cartIcon = document.querySelector('.header__icon.header__icon--cart');
      if (cartIcon) {
        cartIcon.click(); // Simulate a click on the cart icon
      }
    })
    .catch(error => {
      //console.error('Error adding products to cart:', error);
    });
  }
}

document.querySelector('#submit-btn').addEventListener('click', function(e) {
  e.preventDefault();
  BundleaddToCart();
});

